module.exports = {
  Base: require('./mixinBase'),
  Needs: require('./mixinNeeds'),
};
